import React, { useEffect, useState } from 'react';
import { getService } from '@Client/runner.hooks/useService';
import './FlowTimelineFile.scss';

type FlowTimelineFileProps = {
  filemeta?: {
    fileId?: string;
  };
};

export const FlowTimelineFile = ({ filemeta }: FlowTimelineFileProps) => {
  const [filename, setFilename] = useState<string | undefined>(undefined);
  const fileService = getService('fileService');
  const pubsubService = getService('pubsubService');

  useEffect(() => {
    if (filemeta?.fileId) {
      fileService.getFileMetaData(filemeta.fileId).then((metaData) => {
        setFilename(metaData.filename);
        pubsubService.publish('FILEUPLOAD_FILE_READY', undefined);
      });
    }
  }, [filemeta?.fileId]);

  const handleDownloadClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (filemeta?.fileId) {
      fileService.downloadById(filemeta.fileId);
    }
  };

  return (
    <div className="timeline-file filename-only">
      {!filename ? (
        <div className="fake-image">
          <span>...</span>
        </div>
      ) : (
        <div className="truncate fileWrapper">
          <a href="#" onClick={handleDownloadClick} title={filename}>
            {filename}
          </a>
        </div>
      )}
    </div>
  );
};
